import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { LoginGate } from './components/LoginGate.js';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root nicht gefunden');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ErrorBoundary>
      <LoginGate>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </LoginGate>
    </ErrorBoundary>
  </React.StrictMode>,
);
